const Givelessons = () => import("@/page/givelessons");
const Givelessmain = () => import("@/page/givelessons/main");
const GiveFolder = () => import("@/page/givelessons/giveFolder");
const GiveRecycle = () => import("@/page/givelessons/giveRecycle");
const filedetail = () => import("@/page/givelessons/filedetail");
const givepage = () => import("@/page/givelessons/givepage");

// ,
export default {
	path: "/Givelessons",
	component: Givelessons,
	children: [{
			path: 'givelessmain',
			name: 'givelessmain',
			component: Givelessmain,
		}, {
			path: 'givefolder',
			name: 'givefolder',
			component: GiveFolder,
		}, {
			path: 'giverecycle',
			name: 'giverecycle',
			component: GiveRecycle,
		},
		{
			path: 'filedetail',
			name: 'filedetail',
			component: filedetail,
		},
		{
			path: 'givepage',
			name: 'givepage',
			component: givepage,
		}
	]
};



// WEBPACK FOOTER //
// ./src/router/givelessions.js